import { ChangeEvent, Dispatch, SetStateAction } from "react";

import { useWindowSize } from "@newsela/angelou";

import { CondensedSearchInput } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/CondensedSearchInput";
import { ISuggestion } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu.constants";
import {
  condensedSuggestionsPopoutVisibilityCss,
  expandedSuggestionsPopoutVisibilityCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchSuggestionsPopout/SearchSuggestionsPopout.styles";
import { SuggestionsList } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchSuggestionsPopout/SuggestionsList";
import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

const SearchSuggestionsPopout = ({
  onChange,
  onKeyDown,
  inputValue,
  suggestions = [],
  setShowSuggestions,
  resetSearchMenuToDefault,
}: ISearchInputSuggestionsPopout) => {
  const { width: windowWidth } = useWindowSize();

  const customOnKeyDown = (event: KeyboardEvent) => {
    onKeyDown(event);
    if (event.key === "Tab") {
      setShowSuggestions(true);
    }
  };

  const hasSuggestions = !!suggestions.length;
  const showCondensedSuggestionsPopout = windowWidth < NAVBAR_BREAKPOINTS.sm;

  return (
    <div data-testid="search-suggestions-popout">
      {showCondensedSuggestionsPopout ? (
        <div css={condensedSuggestionsPopoutVisibilityCss}>
          <CondensedSearchInput
            inputValue={inputValue}
            onChange={onChange}
            onKeyDown={customOnKeyDown}
            setShowSuggestions={setShowSuggestions}
            onClick={resetSearchMenuToDefault}
          />

          {hasSuggestions && (
            <SuggestionsList
              inputValue={inputValue}
              suggestions={suggestions}
              setShowSuggestions={setShowSuggestions}
            />
          )}
        </div>
      ) : (
        hasSuggestions && (
          <div css={expandedSuggestionsPopoutVisibilityCss}>
            <SuggestionsList
              inputValue={inputValue}
              suggestions={suggestions}
              setShowSuggestions={setShowSuggestions}
            />
          </div>
        )
      )}
    </div>
  );
};

interface ISearchInputSuggestionsPopout {
  inputValue: string;
  suggestions: ISuggestion[] | string[];
  resetSearchMenuToDefault: () => void;
  onKeyDown: (event: KeyboardEvent) => void;
  setShowSuggestions: Dispatch<SetStateAction<boolean>>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

SearchSuggestionsPopout.displayName = "SearchInputSuggestions";
export { SearchSuggestionsPopout };
